
  const cardPaymentConfig = {
    path: "/settings/credit-card",
    name: "cardPaymentConfig",
    component: () => import(/* webpackChunkName: "card_payment_config" */ "@/components/cardPaymentConfig/CardPaymentConfigIndex.vue"),
    children: [
      { path: "view/:id", component: () => import(/* webpackChunkName: "card_payment_config" */ "@/components/cardPaymentConfig/CardPaymentConfigView.vue"), name: "cardPaymentConfigView" },
      { path: "edit/:id", component: () => import(/* webpackChunkName: "card_payment_config" */ "@/components/cardPaymentConfig/CardPaymentConfigEdit.vue"), name: "cardPaymentConfigEdit" },
      { path: "create", component: () => import(/* webpackChunkName: "card_payment_config" */ "@/components/cardPaymentConfig/CardPaymentConfigCreate.vue"), name: "cardPaymentConfigCreate"}
    ],
    meta: { authorize: [], requiresAuth: true }
  };

export default cardPaymentConfig;
    